export default __webpack_public_path__ + "static/media/icon-veloprime-white.f1d00402.png";